function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactingDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Contacting driver",
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 312,
    viewBox: "0 0 312 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 231",
    style: {
      stroke: "rgba(247,247,247,.7)",
      strokeWidth: 4,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 156,
    r: 156,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 156,
    r: 154,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1982",
    d: "m314.04 102.988-2.224-4.964h3.518a8.4 8.4 0 1 0 0-16.8h-11.046l-8.859-19.8a11.279 11.279 0 0 0-10.3-6.673h-7.218L275.105 47a9.6 9.6 0 0 0-9.041-6.328h-21.709A9.62 9.62 0 0 0 235.314 47l-2.807 7.746h-7.054a11.278 11.278 0 0 0-10.3 6.673l-8.859 19.8H195.25a8.4 8.4 0 1 0 0 16.8h3.518l-2.224 4.964a13.669 13.669 0 0 0-10.134 13.187v28.165a3.543 3.543 0 0 0 3.554 3.546h8.786v9.946a7.2 7.2 0 0 0 7.218 7.2h8.968a7.2 7.2 0 0 0 7.218-7.2v-9.947h66.038v9.946a7.2 7.2 0 0 0 7.218 7.2h8.968a7.2 7.2 0 0 0 7.218-7.2v-9.946h8.95a3.543 3.543 0 0 0 3.554-3.546V116.17a13.7 13.7 0 0 0-10.134-13.182zm-13.689 30.274h-.62a8.109 8.109 0 1 1 0-16.219h.62a8.109 8.109 0 1 1 0 16.219zm-88.768 0h-.62a8.109 8.109 0 1 1 0-16.219h.62a8.109 8.109 0 1 1 0 16.219zm15.93-64.112h55.594l11.684 26.11h-78.962zm46.808 65.675h-38a9.655 9.655 0 1 1 0-19.31h38a9.655 9.655 0 1 1 0 19.31z",
    transform: "translate(-94.976 70.193)",
    style: {
      fill: "#0f8560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1983",
    d: "M194.036 50.839A4.078 4.078 0 0 0 196 56.275a3.932 3.932 0 0 0 1.746.382 4.092 4.092 0 0 0 3.709-2.346 11.322 11.322 0 0 1 3.236-4.091 11.029 11.029 0 0 1 4.927-2.2 4.093 4.093 0 0 0-1.455-8.055 19.36 19.36 0 0 0-14.109 10.873z",
    transform: "translate(-88.975 72.189)",
    style: {
      fill: "#0f8560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1984",
    d: "M192.2 53.167a22.953 22.953 0 0 1 19.019-14.782 4.088 4.088 0 0 0-.891-8.128 31.142 31.142 0 0 0-25.8 20.037 4.09 4.09 0 0 0 2.4 5.273 3.994 3.994 0 0 0 1.436.255 4.111 4.111 0 0 0 3.836-2.655z",
    transform: "translate(-96.731 65.153)",
    style: {
      fill: "#0f8560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1985",
    d: "M213.129 28.157a4.086 4.086 0 0 0-.655-8.146 42.883 42.883 0 0 0-37.255 29 4.1 4.1 0 0 0 2.546 5.2 4.144 4.144 0 0 0 1.327.218 4.1 4.1 0 0 0 3.873-2.764 34.612 34.612 0 0 1 30.164-23.492z",
    transform: "translate(-104.313 56.781)",
    style: {
      fill: "#0f8560"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactingDriver);
export default __webpack_public_path__ + "static/media/contacting-driver.931682e4.svg";
export { ForwardRef as ReactComponent };